import { useEffect, useState } from "react";
import api from "../utils/api";
import socket from "../socket";

const EMPTY = { tables: {}, orders: {} };
const REFRESH_MS = 60 * 1000; // waiting minutes count down even when nothing changes

// Kitchen waiting times for the given tables (allocation ids) and orders
// (orderId numbers). Refreshes live when the kitchen queue changes.
// Returns { tables: { [allocationId]: eta }, orders: { [orderId]: eta } }
export function useKitchenEta({ allocationIds = [], orderIds = [] }) {
  const [etas, setEtas] = useState(EMPTY);
  const allocKey = [...new Set(allocationIds.filter(Boolean).map(String))].sort().join(",");
  const orderKey = [...new Set(orderIds.filter(Boolean).map(String))].sort().join(",");

  useEffect(() => {
    if (!allocKey && !orderKey) {
      setEtas(EMPTY);
      return undefined;
    }
    let cancelled = false;
    let timer = null;

    const load = async () => {
      try {
        const { data } = await api.get("/kitchen/eta", {
          params: { allocationIds: allocKey, orderIds: orderKey },
        });
        if (!cancelled) setEtas(data || EMPTY);
      } catch {
        // Waiting times are a nice-to-have: keep the last ones on error
      }
    };
    // Several kitchen changes often land together
    const onKitchenUpdated = () => {
      clearTimeout(timer);
      timer = setTimeout(load, 400);
    };

    load();
    const interval = setInterval(load, REFRESH_MS);
    socket.on("kitchen-updated", onKitchenUpdated);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      clearInterval(interval);
      socket.off("kitchen-updated", onKitchenUpdated);
    };
  }, [allocKey, orderKey]);

  return etas;
}
